//
// Shop: Global events on add\remove product to wishlist
//

"use strict";

( function($, waTheme) {

    var Wishlist = ( function($) {

        var change_functions = [];

        Wishlist = function(options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$count = that.$wrapper.find(".js-wishlist-wrapper__count");
            that.onChange = options["onChange"];

            // VARS

            // DYNAMIC VARS
            that.count = null;

            // INIT
            that.initClass();
        };

        Wishlist.prototype.initClass = function() {
            var that = this;

            $(document).on('click', '.js-add-wishlist-button', function () {
                var product_id = $(this).data("product-id"),
                    $buttons = $(`.js-add-wishlist-button[data-product-id="${product_id}"]`),
                    is_added = $(this).hasClass("active");

                $buttons.toggleClass("active");
                if (is_added) {
                    $buttons.find(".b-wishlist__text").text(window.waTheme.locale.to_wishlist);
                } else {
                    $buttons.find(".b-wishlist__text").text(window.waTheme.locale.in_wishlist);
                }

                that.addToWishlist($(this), product_id);
            });

            $(document).on('click', '.js-wishlist-clear', function () {
                var title = $(this).data('title');
                var text = $(this).data('text');
                that.clear(title, text);
            });

            if (that.onChange && (typeof that.onChange === "function") ) {
                change_functions.push(that.onChange);
            }
        };

        Wishlist.prototype.update = function() {
            var that = this,
                wishlist = $.cookie("shop_wishlist"),
                count;

            wishlist = (wishlist) ? wishlist.split(',') : [];
            count = wishlist.length;

            if ( count > 0 ) {
                that.$count.text(count);
                that.toggle(true);
            } else {
                that.$count.text(0);
                that.toggle();
            }

            that.count = count;

            $.each(change_functions, function(index, func) {
                try {
                    func(that);
                } catch(e) {
                    console.log(e.message);
                }
            });
        };

        Wishlist.prototype.toggle = function(show) {
            var that = this,
                active_class = "d-none";

            if (show) {
                that.$count.removeClass(active_class);
            } else {
                that.$count.addClass(active_class);
            }
        };

        /**
         * @param {String|Number} product_id
         * @return {Boolean}
         * */
        Wishlist.prototype.addToWishlist = function($button, product_id) {
            var that = this;

            product_id = product_id + "";

            var cookie_name = "shop_wishlist",
                cookie_wishlist = $.cookie(cookie_name),
                wishlist_ids = (cookie_wishlist) ? cookie_wishlist.split(',') : [],
                index = wishlist_ids.indexOf(product_id),
                is_added = (index >= 0);

            if (is_added) {
                remove(product_id);
                that.update();
                that.toast($button, window.waTheme.locale.product_removed_from_wishlist);

                $button.removeClass("active");
                $button.find(".b-wishlist__text").text(window.waTheme.locale.to_wishlist);
            } else {
                add(product_id);
                that.update();
                that.toast($button, window.waTheme.locale.product_added_to_wishlist);

                $button.addClass("active");
                $button.find(".b-wishlist__text").text(window.waTheme.locale.in_wishlist);
            }

            return !is_added;

            /**
             * @param {String} product_id
             * */
            function add(product_id) {
                wishlist_ids.push(product_id);
                $.cookie(cookie_name, wishlist_ids.join(','), {expires: 30, path: '/'});
            }

            /**
             * @param {String} product_id
             * */
            function remove(product_id) {
                wishlist_ids.splice(index, 1);

                if (wishlist_ids.length > 0) {
                    $.cookie(cookie_name, wishlist_ids.join(','), { expires: 30, path: '/'});
                } else {
                    $.cookie(cookie_name, "", {path: '/'});
                }
            }
        };

        Wishlist.prototype.toast = function($button, text) {
            var that = this,
                product_name = $button.data("product-name"),
                product_image = $button.data("product-image");

            let toastHTML =
                `<div class="b-products-toast d-flex align-items-center">
                    <div class="b-products-toast__image">
                       <img src="${product_image}">
                    </div>
                    <div class="ms-3">
                        <div class="fs-md fw-bold mb-1">
                            ${text}
                        </div>
                        <div class="fs-sm">
                            ${product_name}
                        </div>
                    </div>
                </div>`;

            console.log(product_name);

            const toast = new window.waTheme.init.site.Toast({
                html: toastHTML
            });
        };

        Wishlist.prototype.clear = function (title, text) {
            var that = this,
                cookie_name = "shop_wishlist";

            $.cookie(cookie_name, "", {path: "/"});

            // Удаляем фильтрация товаров и сами товары, если мы на странице поиска
            var $search_page = $(".s-search-page");
            if ($search_page.length) {
                $search_page.find(".s-search-empty").removeClass("is-hidden");
                $search_page.find(".b-search-wishlist-filter").remove();
                $search_page.find(".b-search-wishlist-products").remove();
            }

            // Обновляем счетчик
            that.update();
        };

        /**
         * @param {Function} func
         * */
        Wishlist.prototype.onChange = function(func) {
            if (typeof func === "function") {
                change_functions.push(func);
            }
        };

        return Wishlist;
    })($);

    waTheme.init.shop.Wishlist = Wishlist;

    let $wishlist = $(".js-wishlist-wrapper");
    if ($wishlist.length) {
        waTheme.apps["shop"].wishlist = new window.waTheme.init.shop.Wishlist({
            $wrapper: $wishlist,
            // onChange: function(wishlist) {
                // var hover_class = "with-hover";
                // if (wishlist.count > 0) {
                //     $wishlist.addClass(hover_class);
                // } else {
                //     $wishlist.removeClass(hover_class);
                // }
            // }
        });
    }

})(jQuery, window.waTheme);
